import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ReportPageItem from './ReportPageItem';
import Collapsible from 'react-collapsible';
import SVGSpriteUrl from './assets/icon-sprite.svg';

const StyledList = styled.ul`
  list-style-type: none;
  padding: 0;
  width: 100%;
`;

const StyledListItem = styled.li`
  width: 100%;
`;

const ReportMenuItemSVG = styled.svg`
  pointer-events: none;
  max-width: 100%;
  max-height: 100%;
  fill: #ffffff;
  stroke: #ffffff;
  opacity: 0.8;
`;

const ReportMenuItemSVGWrapper = styled.div`
  display: inline-block;
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  padding: 3px;
  vertical-align: top;
`;

const StyledListItemName = styled.span`
  line-height: 26px;
  vertical-align: top;
  padding-left: 25px;
`;

const StyledListItemButton = styled.button`
  width: 100%;
  border: none;
  box-sizing: border-box;
  padding: 15px 50px 10px 45px;
  margin: 0;
  text-decoration: none;
  background-color: ${state => (state.isOpened ? '#00013e' : 'inherit')};
  display: ${props => (props.isHidden ? 'none' : 'block')};
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  border-radius: 0;
  cursor: pointer;
  text-align: initial;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-transform: uppercase;
  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    svg {
      fill: #42bcda;
      stroke: #42bcda;
      opacity: 1;
    }
  }
`;

class ReportItem extends PureComponent {
  constructor(props) {
    super(props);

    const isHidden = (props.report.pages.length === 1);

    this.state = {
      isOpened: props.report.id === props.selectedReportId || isHidden,
      isHidden: isHidden
    };
    this.toggleState = this.toggleState.bind(this);
  }

  toggleState() {
    this.setState({
      isOpened: !this.state.isOpened
    });
  }

  getStyledListItemButton() {
    const { report, ...props } = this.props;
    let ReportTypeIcon = '' + SVGSpriteUrl;
    switch (report.type) {
      case 'Dashboard':
        ReportTypeIcon += '#report-type-icon-dashboard';
        break;
      case 'Gas':
        ReportTypeIcon += '#report-type-icon-gas';
        break;
      case 'Water':
        ReportTypeIcon += '#report-type-icon-water';
        break;
      case 'CableTV':
        ReportTypeIcon += '#report-type-icon-cable-tv';
        break;
      case 'Internet':
        ReportTypeIcon += '#report-type-icon-internet';
        break;
      case 'Data':
        ReportTypeIcon += '#report-type-icon-data';
        break;
      case 'Report':
        ReportTypeIcon += '#report-type-icon-report';
        break;
      case 'Electricity':
        ReportTypeIcon += '#report-type-icon-electricity';
        break;
      default:
        ReportTypeIcon += '#report-type-icon-dashboard';
        break;
    }
    return (
      <StyledListItemButton
        onClick={this.toggleState}
        isOpened={this.state.isOpened}
        isHidden={this.state.isHidden}
      >
        <ReportMenuItemSVGWrapper>
          <ReportMenuItemSVG>
            <use href={ReportTypeIcon} />
          </ReportMenuItemSVG>
        </ReportMenuItemSVGWrapper>
        <StyledListItemName>{report.name}</StyledListItemName>
      </StyledListItemButton>
    );
  }

  render() {
    const { report, ...props } = this.props;
    return (
      <StyledListItem>
        <Collapsible
          trigger={this.getStyledListItemButton()}
          open={this.state.isOpened}
        >
          <StyledList>
            {report.pages.map(page => (
              <ReportPageItem
                tabIndex={this.state.isOpened ? 0 : -1}
                key={page.id}
                parentActive={report.id === props.selectedReportId}
                currentReportId={report.id}
                reportPage={page}
                {...props}
              />
            ))}
          </StyledList>
        </Collapsible>
      </StyledListItem>
    );
  }
}

export default ReportItem;
